const POSTCODE_CONSTANTS = {
    UPDATE_POSTCODE_ACTION: 'UPDATE_POSTCODE',
    APPLY_POSTCODE_ACTION: 'APPLY_POSTCODE',
    POSTCODE_INVALID_ACTION: 'POSTCODE_INVALID_ACTION',
    POSTCODE_VALID_ACTION: 'POSTCODE_VALID_ACTION',
    POSTCODE_STORE_START_ACTION: 'POSTCODE_STORE_START_ACTION',
    POSTCODE_STORE_DONE_ACTION: 'POSTCODE_STORE_DONE_ACTION',
    POSTCODE_EXISTS_BUT_NEEDS_TO_BE_LOADED_ACTION: 'POSTCODE_EXISTS_BUT_NEEDS_TO_BE_LOADED_ACTION',
    UPDATE_POSTCODE_API_PATH: '/postcode/set/',
    SET_POSTCODE_SUGGESTION: 'SET_POSTCODE_SUGGESTION',
    ON_CHANGE_POSTCODE_ACTION: 'ON_CHANGE_POSTCODE_ACTION',
};

export default POSTCODE_CONSTANTS;
